import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

import notFoundImg from 'assets/images/404.png';

import './style.scss';

class NotFound extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    platform: PropTypes.string,
  };

  static defaultProps = {
    platform: null,
  };

  constructor(props) {
    super(props);

    this.handleClose = this.handleClose.bind(this);
  }
  handleClose() {
    const { history, platform } = this.props;
    if (platform) {
      window.ci.web.closePage();
      return;
    }
    history.replace('/');
  }

  render() {
    return (
      <React.Fragment>
        <div styleName="not-found">
          <img src={notFoundImg} alt="찾으려는 페이지를 찾을 수 없습니다." />
          <p>찾으려는 페이지를 찾을 수 없습니다.</p>
          <a onClick={this.handleClose} tabIndex={0} role="button">
            <button className="full-radius-btn">홈으로 돌아가기</button>
          </a>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  platform: state.common.platform,
});
const connector = connect(mapStateToProps);

export default connector(NotFound);



// WEBPACK FOOTER //
// ./src/app/pages/errors/NotFound/index.jsx